// What the Lesson Management tabs actually mean.
//
// The tabs were written as UI copy and then compared straight against
// `booking.status`, which is a different vocabulary: the server writes
// "Pending" (createBooking.js, checkoutCart.js), "Finished" (finishLesson.js)
// and "Cancelled" (cancelBooking.js, British spelling). So "Active" matched
// nothing and the tab then spelt "Canceled" matched nothing — those two tabs
// had been permanently empty since the tabs were introduced. lessonTabs.test.js
// pins the mapping so a rename on either side fails loudly instead of silently
// emptying a tab. The tab now reads "Cancelled" (047 D66), the app's spelling.
//
// "Reported" is not a status at all. reportLesson.js (spec 012, D3) leaves the
// lesson "Finished" and marks it with reportedBy/reportedAt/reportReason,
// because a report is a mark on a completed lesson, not a state of its own.
// Its window is therefore ordered by `reportedAt`: Firestore excludes
// documents missing the orderBy field, so the sparse index does the filtering
// and no composite index is needed.

export const LESSON_TABS = [
  { label: "All" },
  { label: "Active", status: "Pending" },
  { label: "Completed", status: "Finished" },
  { label: "Cancelled", status: "Cancelled" },
  { label: "Reported", orderField: "reportedAt" },
];

export const tabByLabel = (label) =>
  LESSON_TABS.find((t) => t.label === label) || LESSON_TABS[0];

// The client-side half of the same question, applied to the loaded window.
// Deliberately wider than the server query for Reported: lessons reported by
// the old client (before reportLesson.js existed) carry `status: "Reported"`
// and may have no `reportedAt`, and the app's own lessonMenu.js already treats
// reportedBy-or-reportedAt as reported. Anything that reaches the window is
// shown rather than filtered back out.
export const matchesTab = (booking, label) => {
  const tab = tabByLabel(label);
  if (tab.label === "All") return true;
  if (tab.label === "Reported") {
    return Boolean(
      booking.reportedBy || booking.reportedAt || booking.status === "Reported"
    );
  }
  return booking.status === tab.status;
};
